/* KPIs */
export const GET_STARTUPS = "GET_STARTUPS"
export const GET_STARTUPS_FAIL = "GET_STARTUPS_FAIL"
export const GET_STARTUPS_SUCCESS = "GET_STARTUPS_SUCCESS"

export const UPDATE_URL_ALIAS = "UPDATE_URL_ALIAS"
export const UPDATE_URL_ALIAS_SUCCESS = "UPDATE_URL_ALIAS_SUCCESS"
export const UPDATE_URL_ALIAS_FAIL = "UPDATE_URL_ALIAS_FAIL"
export const CLOSE_ALERT_BOX = "CLOSE_ALERT_BOX"
